// @flow

import React from 'react'
import styled from 'styled-components'
import i18n from 'live/services/i18n'

type Props = {
    onClearResults: Function,
    msg: string,
    txtClear: string
}

export default function NoResults(props: Props) {
    const { onClearResults } = props

    return (
        <Container>
            <Message>{i18n(props.msg)}</Message>
            <StyledBack onClick={onClearResults}>{i18n(props.txtClear)}</StyledBack>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    padding:40px;
`
const Message = styled.span`
    padding-bottom: 5px;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #868695;
    font-family: ${props => props.theme['font-regular']};
`

const StyledBack = styled.i`
    font-family: ${props => props.theme['font-regular']};
    font-weight: normal;
    cursor: pointer;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: #37a3ef;
    &:hover {
        text-decoration: underline;
    }
`
